var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 123,
    viewBox: "0 0 150 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68945 56.5404V57.8009",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85913 57.2234L3.88911 58.2837",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65405 60.046H3.11043",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74023 62.9187L3.77021 61.8584",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68945 63.2628V62.0023",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79002 62.4225L6.94971 61.5822",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47116 60.3215H8.21069",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63108 57.3805L7.79077 58.2208",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3345 1.5V2.34031",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.814 4.02087H71.6543",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3345 6.54197V5.70166",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.436 4.02087H74.5957",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5964 36.7927V38.0532",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8159 40.5743H22.0764",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5964 43.9356V42.6752",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9582 40.5743H26.6978",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.037 82.6068C116.041 82.6068 116.855 83.4214 116.855 84.4257C116.855 85.4304 116.041 86.2446 115.037 86.2446C114.033 86.2446 113.218 85.4304 113.218 84.4257",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.337 106.517C123.561 108.086 122.473 109.539 120.905 109.764C119.337 109.989 117.884 108.9 117.659 107.332C117.435 105.764 118.523 104.31 120.091 104.085",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.359 66.1049C124.439 65.768 126.094 64.4476 126.477 63.0269C126.824 64.2827 128.281 65.768 129.595 65.8804C128.115 66.4042 126.701 67.9601 126.477 69.1825C126.324 67.9366 124.368 66.2865 123.359 66.1049Z",
    fill: "#EBECEE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5266 82.0463C13.0666 81.8779 13.8938 81.2178 14.0854 80.5074C14.2591 81.135 14.9871 81.8779 15.6441 81.9342C14.9047 82.1958 14.1977 82.9739 14.0854 83.5851C14.009 82.9621 13.031 82.1369 12.5266 82.0463Z",
    fill: "#EBECEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5485 23.5996C22.5485 24.3788 21.9172 25.01 21.1385 25.01C20.3595 25.01 19.7285 24.3788 19.7285 23.5996C19.7285 22.8207 20.3595 22.1892 21.1385 22.1892C21.9172 22.1892 22.5485 22.8207 22.5485 23.5996Z",
    fill: "#D1D8DF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.815 112.151C105.815 113.453 104.759 114.509 103.458 114.509C102.156 114.509 101.101 113.453 101.101 112.151C101.101 110.85 102.156 109.794 103.458 109.794C104.759 109.794 105.815 110.85 105.815 112.151Z",
    fill: "#EBECEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.346 20.9998C149.346 22.0327 148.509 22.8697 147.477 22.8697C146.444 22.8697 145.608 22.0327 145.608 20.9998C145.608 19.9669 146.444 19.1299 147.477 19.1299C148.509 19.1299 149.346 19.9669 149.346 20.9998Z",
    fill: "#EBECEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8996 108.332C48.8996 108.983 48.3721 109.511 47.7211 109.511C47.0705 109.511 46.543 108.983 46.543 108.332C46.543 107.681 47.0705 107.153 47.7211 107.153C48.3721 107.153 48.8996 107.681 48.8996 108.332Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1997 14.5386C48.1997 15.3178 47.5683 15.9489 46.7896 15.9489C46.011 15.9489 45.3796 15.3178 45.3796 14.5386C45.3796 13.7597 46.011 13.1282 46.7896 13.1282C47.5683 13.1282 48.1997 13.7597 48.1997 14.5386Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1653 121.386C83.2643 121.728 82.2559 121.276 81.9132 120.375C81.5704 119.474 82.0227 118.465 82.924 118.122C83.8247 117.779 84.8331 118.232 85.1758 119.133C85.519 120.034 85.0663 121.043 84.1653 121.386Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4683 92.2342H67.5268L63.3055 105.665L82.1096 86.6701H70.7885L77.1206 58.8479L59.4683 92.2342Z",
    fill: "url(#paint0_linear_209_2596)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.675 50.4055C105.688 48.9938 103.368 48.0207 100.854 47.6325C99.4793 35.619 89.2809 26.2891 76.8993 26.2891C69.1836 26.2891 62.3158 29.9142 57.9008 35.5539C56.3517 35.035 54.6979 34.7518 52.9736 34.7518C45.0571 34.7518 38.5287 40.6861 37.5863 48.3484C31.0348 50.3794 26.2778 56.4872 26.2778 63.7046C26.2778 72.5573 33.4331 79.7364 42.2773 79.778C42.7328 79.8394 43.1958 79.8751 43.668 79.8751H96.2365C97.2071 80.057 98.2028 80.1562 99.2259 80.1562C108.105 80.1562 115.301 72.9594 115.301 64.0811C115.301 58.3023 112.251 53.2382 107.675 50.4055Z",
    fill: "#F1F2F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9867 41.3001C61.1264 40.5453 59.0562 40.1215 56.874 40.1215C48.7925 40.1215 42.2437 45.8899 42.2437 53.0043C42.2437 53.724 42.3122 54.4285 42.4416 55.1148C48.7249 46.2387 53.0545 42.7138 62.9867 41.3001Z",
    fill: "#E0E2EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_2596",
    x1: 70.7889,
    y1: 35.4392,
    x2: 34.0895,
    y2: 53.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch2);
export default __webpack_public_path__ + "static/media/empty-search-2.97cf138f6b9bd2403693b338e0dc6e21.svg";
export { ForwardRef as ReactComponent };